package com.siriusxm.pia.views.unifiedaggregator.entities

import androidx.compose.runtime.*
import com.siriusxm.pia.SXMUI
import com.siriusxm.pia.components.MessageType
import com.siriusxm.pia.components.messageBox
import com.siriusxm.pia.components.spinner
import com.siriusxm.transcripts.VttViewer
import io.ktor.client.*
import io.ktor.client.request.*
import io.ktor.client.statement.*
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

/**
 * Displays a transcript from a VTT URL.
 *
 * This component fetches the VTT content from the provided URL and renders it
 * using the vttViewer component with formatted and raw view options.
 *
 * @param transcriptionUrl The URL to the VTT transcript file
 */
@Composable
fun EntityTranscriptView(transcriptionUrl: String) {
    var vttContent by remember { mutableStateOf<String?>(null) }
    var error by remember { mutableStateOf<String?>(null) }
    var isLoading by remember { mutableStateOf(true) }
    val scope = rememberCoroutineScope()

    LaunchedEffect(transcriptionUrl) {
        isLoading = true
        error = null
        vttContent = null
        try {
            val response = HttpClient().get(transcriptionUrl)
            vttContent = response.bodyAsText()
        } catch (e: Exception) {
            error = e.message ?: "Failed to load transcript"
        } finally {
            isLoading = false
        }
    }

    when {
        isLoading -> {
            Div({
                style {
                    padding(32.px)
                    textAlign("center")
                }
            }) {
                spinner()
                P({
                    style {
                        marginTop(8.px)
                        color(SXMUI.subtleTextColor.value())
                    }
                }) {
                    Text("Loading transcript...")
                }
            }
        }
        error != null -> {
            messageBox(
                "Error loading transcript: $error",
                MessageType.ALERT
            )
        }
        vttContent != null -> {
            VttViewer(vttContent!!, showViewToggle = true)
        }
    }
}
